import React, { useContext } from 'react';
import Form from 'react-bootstrap/Form';
import Button from '@/components/Button/Button';
import classes from './Documents.module.scss';
import t from '@/utils/Language/Documents-translations';
import { Row, Col } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import uploadedDocuments from '@/utils/api/odas/uploaded_documents';
import { toastContext } from '@/context/toast.context';

const DocumentConsent = ({ agencyClient, onConsentSubmit }) => {
  const {
    register,
    formState: { errors }
  } = useForm();
  const { addToast } = useContext(toastContext);

  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData(e.target),
      formDataObj = Object.fromEntries(formData.entries());
    uploadedDocuments.updateDocumentConsent(formDataObj, agencyClient?.id).then((resp) => {
      if (resp?.status === 200) {
        onConsentSubmit();
      } else {
        addToast({ type: 'error' });
      }
    });
  };

  return (
    <div className={classes.consent}>
      <div className={classes.header}>
        {t('To upload documents or view documents has given you access to, you must agree to the following:', { client: agencyClient?.first_name })}
      </div>
      <ul>
        <li>{t('I will be able to access sensitive documents uploaded by clients I work with, and I agree to protect this information.')}</li>
        <li>{t('I will follow relevant Federal, State and local laws related to confidentiality and privacy.')}</li>
        <li>{t('I will not disclose these documents in any way beyond the specific purpose they are shared with me.')}</li>
        <li>{t('I accept that the owner of these documents can revoke access at any time.')}</li>
        <li>{t('I will immediately delete any document that I upload for a client upon their request.')}</li>
        <li>
          {t(
            'I will not accept documents shared by One Degree users I have no relationship with, and will remove my access to any I mistakenly accept.'
          )}
        </li>
      </ul>
      <div className={classes.acceptConsent}>
        <div className={classes.footer}>
          <Form onSubmit={handleSubmit}>
            <Row>
              <Col md={{ span: 4, offset: 4 }} xs="12" className={classes.btnAgree}>
                <Button type="primary" styles={{ width: 'full' }} text={t('Agree')} htmlType="submit" />
              </Col>
            </Row>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default DocumentConsent;
